/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebstepcompose3Inputs */

const en_placewebstepcompose3 = /** @type {(inputs: Placewebstepcompose3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putting the profile together`)
};

const de_placewebstepcompose3 = /** @type {(inputs: Placewebstepcompose3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil zusammenstellen`)
};

/**
* | output |
* | --- |
* | "Putting the profile together" |
*
* @param {Placewebstepcompose3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebstepcompose3 = /** @type {((inputs?: Placewebstepcompose3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebstepcompose3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebstepcompose3(inputs)
	return de_placewebstepcompose3(inputs)
});
export { placewebstepcompose3 as "placeWebStepCompose" }